import { render, staticRenderFns } from "./AgentListMenu.vue?vue&type=template&id=8630ea2e"
import script from "./AgentListMenu.vue?vue&type=script&lang=js"
export * from "./AgentListMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports